import React from 'react';
import FeatureFlagPlaceholder from 'components/ui/FeatureFlagPlaceholder';

export default function Governance() {
  return (
    <FeatureFlagPlaceholder
      title="Governance"
      description="On-chain governance with proposal creation, voting, quorum management, and LP participation rights will be available in Phase 2."
      phase="Phase 2"
    />
  );
}
